/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	line: {
		height: '1px',
		width: '100%',
		backgroundColor: token('color.background.accent.gray.subtle'),
	},
	lineRefresh: {
		height: '1px',
		width: '100%',
		backgroundColor: token('color.background.accent.gray.subtler'),
	},
});

export const SeparatorLine = () => <Box xcss={styles.line} />;

export const SeparatorLineRefresh = () => <Box xcss={styles.lineRefresh} />;
